import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/views/front/Layout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('@/views/front/Home.vue') },
      { path: 'tech-category', name: 'TechCategory', component: () => import('@/views/front/TechCategory.vue') },
      { path: 'tech-category/:slug', name: 'CategoryDetail', component: () => import('@/views/front/CategoryDetail.vue') },
      { path: 'articles', name: 'Articles', component: () => import('@/views/front/Articles.vue') },
      { path: 'article/:slug', name: 'ArticleDetail', component: () => import('@/views/front/ArticleDetail.vue') },
      { path: 'resources', name: 'Resources', component: () => import('@/views/front/Resources.vue') },
      { path: 'about', name: 'About', component: () => import('@/views/front/About.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
